<script>

/**
 * Automodal 
 * 
 * Version 1.8
 * Ajutes menores generales. 
 * 
 * Version 1.7
 * Soporte para args,
 * 
 * Version 1.6
 * Agregado el concepto de archetypeReviewCFG, para administración de dependencias:
 *   Review => Review_hijo
 * 
 * Version 1.5
 * Remoción de DIV sobrante.
 * 
 * Version 1.4
 * Agrega el concepto haldeItem, que permite manipular los elementos del archetyipo independientemeente 
 * de si son arreglos de objetos o solo objetos.
 * 
 * Version 1.3
 * Remvue el concepto de archetype como prpoiedad por causar conflictos
 * Recomendado switch por item.key en cArchetype para evitar errores de ejecución.
 * 
 * Version 1.2
 * Corrige la actualización desde cArchetype automática de automodal. 
 * (Requiere "UI Edit automodal@1.10")
 * 
 * Version 1.1
 * Se pasa a ui-edit-auto-modal el parámetro :form-id, requerido para el control de borrado.
 * 
 * Version 1.0
 * Placeholder base
 */

import _ from 'lodash'
import {extractForm} from '@/utils'
import md5 from 'js-md5'

import {archetype, archetypeReviewCFG, automodalHandler} from './archetype'

export default {
    name: 'ReviewAutomodal',
    props: {
        modalClass: {
            type: String,
            default: "ReviewAutomodal",
        },
        conceptId: {
            type: [String, Number],
        },
        args: {
            type: Object,
            default: () => {return {}}
        }
    },
    data: () => {
        return {
            form: extractForm(archetype),
            asides: {
                // administradores: [],
                // distribuidores: [],
            }
        }
    },
    computed: {
        formArchetypeMD5(){
			return md5(JSON.stringify(this.cArchetype))
		},
        cArchetype(){
            let updated = [];
            _.forEach(archetype(), itemsRow => {
                if(!_.isArray(itemsRow)){
                    updated.push(this.handleItem(itemsRow));
                    return
                } 
                let adding = []
                _.forEach(itemsRow, item => {
                    adding.push(this.handleItem(item))
                })
                updated.push(adding)
            })
            return updated
        }
    },
    methods: {
        archetypeReviewCFG,
        storedDone(response){
            console.log('response', response)
        },
        beforeStore(form){
            console.log('beforeStore', form)
            return form;
        },
        handleItem(item) {
            // EVALUACIÓN DINÁMICA POR ELEMENTO DE ARQUETIPO
            if (_.isObjectLike(item)) {
                switch (item.key) {
                    // case 'clientes_id':
                    //     if ((!!this.args) && (!!this.args.clientesId)) {
                    //         item.default = _.clone(this.args.clientesId);
                    //         item.type = undefined;
                    //     }
                    //     break;
                    default:
                        break;
                }
            }
            return item;
        },
        getHandler() {
            return automodalHandler((this.conceptId || this.form.id))
        },
        refresh() {
            this.$emit('refresh');
        },
        checkAsides() {
            const asides = this.$refs.automodal.getAsides();
            if (asides) 
                _.forEach(asides, (aside, asideKey) => {
                    this.asides[asideKey] = aside;
                })
                this.completeForm()
        },
        completeForm() {
            // AQUÍ SE PUEDEN HACER CONSULTAS PARA COMPLETAR EL FORMULARIO CON BASE EN LOS ASIDES, SI FUERA NECESARIO.
            // POR EJEMPLO, SI SE QUIERE COMPLETAR UN SELECT CON LOS MIEMBROS DE UNA ASOCIACIÓN, SE PUEDE HACER AQUÍ.
            this.form.platillo = this.form.mainQueryItem.platillo || '';
            this.form.nombre_completo = this.form.mainQueryItem.nombre_completo || '';
        },
        onDisplay() {
            // SE EJECUTA JUSTO EN EL MOMENTO QUE EL MODAL HA CARGADO DOM COMPLETAMENTE.
        },
        onHidden() {
            // SE EJECUTA JUSTO EN EL MOMENTO QUE EL MODAL SE HA OCULTADO
        },

    },
    watch: {
        'form.id'(){
            
        }
    }
}
</script>

<template>
    <ui-edit-auto-modal v-model="form" ref="automodal" id="review-automodal"
        :size="form.id ? 'md': 'md'"
        :label="form.id ? 'Detalle de la reseña' : 'Nueva reseña'" 
        :form-id="form.id" 
        :form-archetype="cArchetype" 
        :handler="getHandler()"  
        :allow-aside="parseInt(form.id)>0 && false" 
        :allow-delete="false"
        :form-key="formArchetypeMD5"
        :beforeStore="beforeStore"
        :args="args"
        :keep-on-success="true"
        :modalClass="modalClass"
        view-only
        @successStoring="storedDone"
        @refresh="refresh" 
        @defined="checkAsides" 
        @display="onDisplay" 
        @hidden="onHidden">
        <slot name="default"><i class="fa fa-cog"></i></slot>
        <div slot="top">
            <img-portal v-if="form.mainQueryItem && form.mainQueryItem.platillo_imagen_uri" class="img-platillo" :src="form.mainQueryItem.platillo_imagen_uri" />
        </div>
        <b-col slot="aside" cols="7">
            <b-tabs class="mb-4">
                <b-tab title="A" active>
                    <!-- 
                    <associationsmembers-quicktable :args="{ 
                        associationsId: form.id, 
                        passions: form.AssociationsCfg
                    }"/>
                    -->
                    <div>...A</div>
                </b-tab>
                <b-tab title="B">
                    <div>...B</div>
                </b-tab>
            </b-tabs>
        </b-col>
        <b-col slot="bottom">
            <!-- AGREGAR AL FONDO... -->
        </b-col>
    </ui-edit-auto-modal>
</template>

<style lang="scss">
    .ReviewAutomodal {
        .img-platillo {
            width: 100%;
            height: auto;
            // object-fit: cover;
            aspect-ratio: 100 / 70;
            margin-bottom: 1em;
            display: block;
        }
        .arch-col-fecha {
            flex: 1 0 calc(100%/3*2);
        }
        .arch-col-calificacion {
            font-weight: bold;
            flex: 1 0 calc(100%/3);
        }
    }
</style>